import { logInfo } from '@rs-core/utils/logger';

export const MD_AI_REPORT_CREATION_PROGRESS = {
	NOT_STARTED: 'NOT_STARTED',
	IN_PROGRESS: 'IN_PROGRESS',
	COMPLETED: 'COMPLETED',
	FAILED: 'FAILED',
};

const initialMdAiState = {
	isMDAiModalVisible: false,
	mdAiInitialReportCreationData: null,
	mdAiReportData: null,
	mdAiIframeReady: false,
	mdAiReportCreationProgress: MD_AI_REPORT_CREATION_PROGRESS.NOT_STARTED,
};

const createAiReportingIntegrationSlice = set => ({
	aiReportingIntegration: {
		mdAi: {
			...initialMdAiState,
			setMdAiIframeReady: mdAiIframeReady =>
				set(state => {
					logInfo('createAiReportingIntegrationSlice:setMDAiIframeReady', 'mdAiIframeReady', mdAiIframeReady);
					return {
						aiReportingIntegration: {
							...state.aiReportingIntegration,
							mdAi: { ...state.aiReportingIntegration.mdAi, mdAiIframeReady },
						},
					};
				}),
			setIsMDAiModalVisible: isMDAiModalVisible =>
				set(state => {
					logInfo(
						'createAiReportingIntegrationSlice:setIsMDAiModalVisible',
						'isMDAiModalVisible',
						isMDAiModalVisible
					);
					return {
						aiReportingIntegration: {
							...state.aiReportingIntegration,
							mdAi: {
								...state.aiReportingIntegration.mdAi,
								isMDAiModalVisible,
							},
						},
					};
				}),
			setMdAiInitialReportCreationData: mdAiInitialReportCreationData =>
				set(state => {
					logInfo(
						'createAiReportingIntegrationSlice:setMdAiInitialReportCreationData',
						'mdAiInitialReportCreationData',
						mdAiInitialReportCreationData
					);
					return {
						aiReportingIntegration: {
							...state.aiReportingIntegration,
							mdAi: {
								...state.aiReportingIntegration.mdAi,
								mdAiInitialReportCreationData,
							},
						},
					};
				}),
			setMdAiReportData: mdAiReportData =>
				set(state => {
					logInfo('createAiReportingIntegrationSlice:setMdAiReportData', 'mdAiReportData', mdAiReportData);
					return {
						aiReportingIntegration: {
							...state.aiReportingIntegration,
							mdAi: {
								...state.aiReportingIntegration.mdAi,
								mdAiReportData,
							},
						},
					};
				}),
			setMdAiReportCreationProgress: mdAiReportCreationProgress =>
				set(state => {
					logInfo(
						'createAiReportingIntegrationSlice:setMdAiReportCreationProgress',
						'mdAiReportCreationProgress',
						mdAiReportCreationProgress
					);
					return {
						aiReportingIntegration: {
							...state.aiReportingIntegration,
							mdAi: { ...state.aiReportingIntegration.mdAi, mdAiReportCreationProgress },
						},
					};
				}),
			resetMdAiStore: () =>
				set(state => {
					logInfo(
						'createAiReportingIntegrationSlice:resetMdAiStore',
						'Resetting MD AI store to initial state',
						initialMdAiState
					);
					return {
						aiReportingIntegration: {
							...state.aiReportingIntegration,
							mdAi: {
								...state.aiReportingIntegration.mdAi,
								...initialMdAiState,
							},
						},
					};
				}),
		},
	},
});

export default createAiReportingIntegrationSlice;
